import React, {Component} from 'react';
import * as firebase from 'firebase';
import MetaTags from 'react-meta-tags';
import ReactQuill from 'react-quill';
import ReactDom from 'react-dom';
import AvatarCropper from "react-avatar-cropper";
import 'react-quill/dist/quill.snow.css';

export default class EditAuthorityPost extends Component {
  constructor() {
    super();
    this.state = {
      blogName: '',
      blogTag: '',
      secondTag: '',
      otherTag1: '',
      otherTag2: '',
      otherTag3: '',
      enTag: '',
      listPhoto: '',
      author: '',
      authorUrl: '',
      value: '',
      description: '',
      showRemoveBox: false,
      cropperOpen: false,
      img: null,
      croppedImg: "",
      hasSaved: false
    }
    this.handleChangeBlogName = this.handleChangeBlogName.bind(this);
    this.handleChangeDescription = this.handleChangeDescription.bind(this);
    this.handleChangeBlogTag = this.handleChangeBlogTag.bind(this);
    this.handleChangeSecondTag = this.handleChangeSecondTag.bind(this);
    this.handleChangeOtherTag1 = this.handleChangeOtherTag1.bind(this);
    this.handleChangeOtherTag2 = this.handleChangeOtherTag2.bind(this);
    this.handleChangeOtherTag3 = this.handleChangeOtherTag3.bind(this);
    this.handleChangeEnTag = this.handleChangeEnTag.bind(this);
    this.handleChangeListPhoto = this.handleChangeListPhoto.bind(this);
    this.handleChangeAuthor = this.handleChangeAuthor.bind(this);
    this.handleChangeAuthorUrl = this.handleChangeAuthorUrl.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleRemoveBox = this.handleRemoveBox.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleCrop = this.handleCrop.bind(this);
    this.handleRequestHide = this.handleRequestHide.bind(this);
    this.handleYourSaved = this.handleYourSaved.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0,0)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {

        let id = this.props.match.params.id;
        const EditPostRef = firebase.database().ref('MedicalTeamPosts/').orderByChild('id').equalTo(id);
        EditPostRef.on('value', snap => {
          snap.forEach((child) => {
             this.setState({
               blogName: child.val().blogName,
               description: child.val().description,
               blogTag: child.val().blogTag,
               secondTag: child.val().secondTag,
               otherTag1: child.val().otherTag1,
               otherTag2: child.val().otherTag2,
               croppedImg: child.val().croppedImg,
               author: child.val().author,
               authorUrl: child.val().authorUrl,
               value: child.val().value,
               id: child.val().id,
               name: child.val().name
             })
          })
        })
      } else {
          window.location = ('/')
      }
    })
  }

  onChange(value) {
    this.setState({value: value})
  }

  handleChangeBlogName(event) {
    this.setState({blogName: event.target.value})
  }
  handleChangeDescription(event) {
    this.setState({description:event.target.value})
  }
  handleChangeBlogTag(event) {
    this.setState({blogTag: event.target.value})
  }

  handleChangeSecondTag(event) {
    this.setState({secondTag: event.target.value})
  }

  handleChangeOtherTag1(event) {
    this.setState({otherTag1: event.target.value})
  }

  handleChangeOtherTag2(event) {
    this.setState({otherTag2: event.target.value})
  }

  handleChangeOtherTag3(event) {
    this.setState({otherTag3: event.target.value})
  }

  handleChangeEnTag(event) {
    this.setState({enTag: event.target.value})
  }

  handleChangeAuthor(event) {
    this.setState({author: event.target.value})
  }

  handleChangeAuthorUrl(event) {
    this.setState({authorUrl: event.target.value})
  }
  handleChangeListPhoto(event) {
    this.setState({listPhoto: event.target.value})
  }
  handleRemoveBox() {
    this.setState({
        showRemoveBox: true
    })  
  }
  handleRemove(event) {
    event.preventDefault()
    let id = this.props.match.params.id;
    const removeRef = firebase.database().ref('MedicalTeamPosts/').child(id);
    removeRef.remove();
    window.location = ('/UserProfile/AuthorityPostTable');
  }
  handleCancel() {
    this.setState({
      showRemoveBox: false
    })  
  }
  handleFileChange(dataURI) {
    this.setState({
      img: dataURI,
      croppedImg: this.state.croppedImg,
      cropperOpen: true
    });
  }
  handleCrop(dataURI) {
    this.setState({
      cropperOpen: false,
      img: null,
      croppedImg: dataURI
    });
  }
  handleRequestHide() {
    this.setState({
      cropperOpen: false
    });
  }
  handleSave(event, value) {
    let id = this.props.match.params.id;
    const postRef = firebase.database().ref('MedicalTeamPosts/').child(id)
    postRef.update({
      blogName: this.state.blogName,
      description: this.state.description,
      blogTag: this.state.blogTag,
      secondTag: this.state.secondTag,
      otherTag1: this.state.otherTag1 ? this.state.otherTag1 : null,
      otherTag2: this.state.otherTag2 ? this.state.otherTag2 : null,
      croppedImg: this.state.croppedImg ? this.state.croppedImg : null,
      author: this.state.author ? this.state.author : null,
      authorUrl: this.state.authorUrl ? this.state.authorUrl : null,
      createDate: new Date().toLocaleDateString(),
      createTime: new Date().toLocaleTimeString(),
      value: this.state.value ? this.state.value : null
    })
    this.setState({hasSaved: true})
    event.preventDefault()
  }
  handleYourSaved(){
    window.location = ('/UserProfile/AuthorityPostTable');
  }
  render() {
    const modules = {
      toolbar: [
        [{ 'header': [1, 2, false] }],
        ['bold', 'italic', 'underline','strike', 'blockquote'],
        [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
        ['link', 'image'],
        ['clean']
      ],
    }
    const formats = [
      'header',
      'bold', 'italic', 'underline', 'strike', 'blockquote',
      'list', 'bullet', 'indent',
      'link', 'image'
    ]
    const tagItems = [
      '報健康','吃營養','好運動', '樂旅遊'
    ].map((tagItem) => {
      return <option key={tagItem} value={tagItem}>{tagItem}</option>
    })
    const secondTagItems = [
      '亞健康',
      '過勞',
      '其他資訊',
      '自我肯定',
      '失眠',
      '壓力',
      '憂鬱',
      '尼古丁',
      '趴趴熊',
      '飲食',
      '平和質',
      '氣虛質',
      '陽虛質',
      '陰虛質',
      '痰濕質',
      '濕熱質',
      '血瘀質',
      '氣鬱質',
      '特稟質'
    ].map((secondTagItem) => {
      return <option key={secondTagItem} value={secondTagItem}>{secondTagItem}</option>
    })
    const otherTagItems = [
      '',
      '亞健康建議飲食',
      '過勞建議飲食',
      '失眠建議飲食',
      '壓力建議飲食',
      '憂鬱建議飲食',
      '戒菸建議飲食',
      '趴趴熊建議飲食',
      '飲食行為',
      '平和質建議飲食',
      '氣虛質建議飲食',
      '陽虛質建議飲食',
      '陰虛質建議飲食',
      '痰濕質建議飲食',
      '濕熱質建議飲食',
      '血瘀質建議飲食',
      '氣鬱質建議飲食',
      '特稟質建議飲食'
    ].map((otherTagItem) => {
      return <option key={otherTagItem} value={otherTagItem}>{otherTagItem}</option>
    })
    return(
      <div>
        <MetaTags>
            <title>草學藥事 || 修改文章</title>
            <meta id="og-title" property="og:title" content="修改文章" />
        </MetaTags>
       <h1>修改文章</h1>
       <div className="postForm">
       <form onSubmit={this.handleSave} style={{position: 'relative'}}>
        <div className="container-fluid">
         <div className="row paddLeftAuto">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 paddLeftAuto">
           <div className="group">
            <label htmlFor="blogName">*標題:</label>
            <input type="text" id="blogName" value={this.state.blogName} onChange={this.handleChangeBlogName} required="true" placeholder="請輸入標題" />
           </div>
           <div className="group">
            <label htmlFor="description">*簡述:</label>
            <input type="text" id="description" value={this.state.description} onChange={this.handleChangeDescription} required="true" placeholder="請輸入文章簡述" />
           </div>
           <div className="group">
            <label htmlFor="blogTag">*主分類:</label>
            <select value={this.state.blogTag} onChange={this.handleChangeBlogTag} id="blogTag">
             {tagItems}
            </select>
           </div>
           <div className="group">
            <label htmlFor="secondTag">*次分類:</label>
            <select value={this.state.secondTag} onChange={this.handleChangeSecondTag} id="secondTag">
             {secondTagItems}
            </select>
           </div>
           <div className="group">
           <label htmlFor="otherTag1">其他分類:</label>
            <select value={this.state.otherTag1} onChange={this.handleChangeOtherTag1} id="otherTag1">
             {otherTagItems}
            </select>
           </div>
           <div className="group" style={Jeyu.Flex}>
             <span>
              <label htmlFor="otherTag2">其他分類:</label>
              <input type="text" id="otherTag2" value={this.state.otherTag2} onChange={this.handleChangeOtherTag2}  placeholder="請輸入標籤" />
             </span>
           </div>
           <div className="group">
            <label htmlFor="author">文章出處作者 <small>(引用文章時請確實填寫)</small> :</label>
            <input type="text" id="author" value={this.state.author} onChange={this.handleChangeAuthor} placeholder="請輸入出處作者" />
           </div>
           <div className="group">
            <label htmlFor="authorUrl">文章出處連結 <small>(引用文章時請確實填寫)</small> :</label>
            <input type="text" id="authorUrl" value={this.state.authorUrl} onChange={this.handleChangeAuthorUrl} placeholder="請輸入出處連結" />
           </div>
           <div className="group listPhoto">
           <div className="avatar-photo">
             <label htmlFor="listPhoto" >想更換圖片:<small style={{color: 'rgb(255, 60, 120)'}}>*圖片大小200kb以內</small></label>
             <img src={this.state.croppedImg} alt="縮圖" style={{display: this.state.croppedImg ? 'block' : 'none'}} />
             <FileUpload handleFileChange={this.handleFileChange} />
              <div className="avatar-edit">
               <i className="fa fa-camera"></i>
              </div> 
            </div>
            {this.state.cropperOpen &&
             <AvatarCropper
              onRequestHide={this.handleRequestHide}
              cropperOpen={this.state.cropperOpen}
              onCrop={this.handleCrop}
              image={this.state.img}
              width={400}
              height={260}
             />
            }
           </div>
           <div className="group">
            <label>*文章內容</label>
             <ReactQuill value={this.state.value}
              onChange={this.onChange}
              modules={modules}
              formats={formats}
              />
          </div> 
          </div>
         </div>
        </div>
        <input type="submit" value="送出" className="btnDefault" />
        <input type="button" value="刪除" className="btnDefault" onClick={this.handleRemoveBox} />
        <div style={{display: this.state.showRemoveBox ? 'block' : 'none', position: 'absolute', bottom: '4%', left: 0, background: '#fff', padding: '15px 30px', boxShadow: '0 0 3px rgba(0,0,0,.6)', borderRadius: 7}} >
          <a onClick={this.handleRemove} style={{margin: '0 10px', color: '#dcdcdd'}} >確認刪除</a>
          <a onClick={this.handleCancel} style={{margin: '0 10px'}} >取消</a>
        </div>
       </form>
       <div className="lightBox" style={{display: this.state.hasSaved ? 'flex' : 'none'}}>
              <form className="reportBox">
               <p>文章已經儲存了,謝謝</p>
               <span className="btnDefault" onClick={this.handleYourSaved}>確認</span>
              </form>
       </div>
       </div>
      </div>
    )
  }
}
class FileUpload extends Component {
  constructor() {
    super();
    this.handleFile = this.handleFile.bind(this)
  }
  handleFile(e) {
    var reader = new FileReader();
    var file = e.target.files[0];

    if (!file) return;

    reader.onload = function(img) {
      ReactDom.findDOMNode(this.refs.in).value = '';
      this.props.handleFileChange(img.target.result);
    }.bind(this);
    reader.readAsDataURL(file);
  }
  render() {
     return(
      <input ref="in" type="file" accept="image/*" onChange={this.handleFile} />  
     )
  }
}
const Jeyu = {
  Flex: {
    display: 'flex',
    flex:1
  }
}


// WEBPACK FOOTER //
// ./src/post/EditAuthorityPost.js